import * as React from 'react';
import PropTypes from 'prop-types';
import Button from '@mui/material/Button';
import Avatar from '@mui/material/Avatar';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import ListItemText from '@mui/material/ListItemText';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import Dialog from '@mui/material/Dialog';
import PersonIcon from '@mui/icons-material/Person';
import AddIcon from '@mui/icons-material/Add';
import Typography from '@mui/material/Typography';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import { blue } from '@mui/material/colors';

const emails = ['username@gmail.com', 'user02@gmail.com'];

function SimpleDialog(props) {
  const { onClose, selectedValue, open, gamedata } = props;

  const handleClose = () => {
    onClose(selectedValue);
  };

  const handleListItemClick = (value) => {
    onClose(value);
  };

  return (
    <Dialog onClose={handleClose} open={open}>
      <DialogTitle align='center'><b>{gamedata.title}</b></DialogTitle>
      <DialogContent className="PopupContent">
	    <Card sx={{ maxWidth: 345 }} className="ProductImage">
	      <CardMedia
	        component="img"
	        alt="Game Image"
	        height="140"
	        image={gamedata.thumbnail}
	      />
	    </Card>
	    <div className="ProductDetails">
		    <DialogContentText> <b>Developer</b> : {gamedata.developer} </DialogContentText>
	      	<DialogContentText> <b>Genre</b> : {gamedata.genre} </DialogContentText>
	      	<DialogContentText> <b>Platform</b>  : {gamedata.platform} </DialogContentText>
	      	<DialogContentText> <b>Release-Date</b>  : {gamedata.release_date} </DialogContentText>
	      	<DialogContentText> <b>Descrption</b>  : {gamedata.short_description} </DialogContentText>
	    </div>
      </DialogContent>
    </Dialog>
  );
}

SimpleDialog.propTypes = {
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
};

export default function GamePopupDialog({gamedata}) {
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
  	console.log(gamedata);
    setOpen(true);
  };

  const handleClose = (value) => {
    setOpen(false);
  };

  return (
    <div>
      <Button variant="contained" 
      		  onClick={handleClickOpen}
      		  size="small"
      		  color="secondary">
        Game Page
      </Button>
      <SimpleDialog
        open={open}
        onClose={handleClose}
        gamedata={gamedata}
      />
    </div>
  );
}
